import { StaticImage } from "gatsby-plugin-image"

const currencyResearchData = {
  color: "#e5dcff",
  heroTitle: `Breaking Stereotypes at the Banknote Conference`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/currency-research/hero.png"
      alt="currency-research-finance-summit-photo-ai-hero"
    />
  ),
  metrics: {
    quote: `Worried that your senior audience can’t handle tech at your events? Here is how Premagic won over the older generation at Currency Research’s Banknote Conference.`,
  },
  images: [
    {
      img: (
        <StaticImage
          src="../../images/case-study/currency-research/banner.png"
          alt="currency-research-finance-summit-photo-ai-banner"
        />
      ),
    },
    {
      img: (
        <StaticImage
          src="../../images/case-study/currency-research/banner.png"
          alt="currency-research-finance-summit-photo-ai-secondary-banner"
        />
      ),
    },
  ],
  gallery: (
    <StaticImage
      src="../../images/case-study/currency-research/gallery.png"
      alt="currency-research-finance-summit-photo-ai-gallery"
    />
  ),
  caseStudyData: [
    {
      title: "The Challenge",
      info1: `When <b>Currency Research (CR)</b>, the global leader in cash and payments industry events, hosted their prestigious <b>Banknote Conference</b>, they wanted more than just insightful discussions and networking—they wanted <b>real engagement</b><br/><br/>But their audience presented a unique challenge: an older demographic of senior executives and industry experts. While they loved what Premagic had to offer, they weren’t entirely sure if their audience would take to it.<br/><br/>The CR team’s skepticism wasn’t unfounded. Older attendees typically value professional photos but struggle with the <b>time-consuming, outdated process</b> of finding and receiving them. Premagic’s <b>AI-powered photo distribution</b> promised a faster, simpler way—but would it resonate?`,
      inlineLink: {
        text: "HOW G2 ACHIEVED 4X MORE REGISTRATIONS WITH PREMAGIC",
        link: "https://premagic.com/case-study/g2-live/",
      },
    },
    {
      title: "The Premagic Effect",
      info1: `Surprisingly, it didn’t just resonate—it <b>shattered expectations.</b><br/><br/>By leveraging <b>facial recognition technology</b>, Premagic allowed attendees to retrieve their professional photos almost instantly. Without the hassle of hunting through galleries or chasing after photographers— all of the attendees got their photos delivered straight to their inboxes.<br/><br/>Here’s where the magic unfolded:<br/><br/>A few early adopters tried it on Day 1, retrieving their photos effortlessly, shared their photos with colleagues, prompting others to ask, “How do I get mine?”<br/><br/>Those attendees quickly became ambassadors, encouraging hesitant peers to give it a try by demonstrating how easy it was to use<br/><br/>By Day 2, nearly everyone at the conference, young and old, had tried it, sparking a <b>mini viral loop within the event.</b>`,
    },
    {
      title: "Breaking stigmas and building trust",
      info1: `This was when we realized something remarkable: contrary to stereotypes, <b>older attendees wanted their photos even more than younger ones</b>. While the younger generation often makes do with clicks on their own phones, the older audience usually prefers the chance to have high-quality, professional pictures.<br/><br/>While clicking pictures, collating them, and posting them on social media might seem like a tedious task for some, Premagic simplifies the process. The attendees get their face-matched photos, complete with ready-to-post templates with auto-generated captions, making it effortless to share on social media with just a click of a button.<br/><br/>This ended up generating a stream of <b>user-generated content (UGC)</b> that amplified the event’s reach far beyond the conference walls.<br/><br/><b>A Mindset Shift</b><br/><br/><b>Bhakti Kapasi, our account executive shared:</b> “There’s this stigma that older audiences won’t engage with technology. We were hoping to break that notion completely and I think we were successful.  We saw attendees go from curious to enthusiastic in hours. Watching them share their photos with colleagues and hearing their excitement—it was absolutely fantastic.”`,
      inlineLink: {
        text: "CONVERTING ATTENDEES AT GITEX GLOBAL INTO CONTENT CREATORS",
        link: "https://premagic.com/case-study/gitex-global",
      },
      image: (
        <StaticImage
          src="../../images/case-study/currency-research/banner2.png"
          alt="currency-research-finance-summit-photo-ai-building"
        />
      ),
    },
    {
      title: "The Outcome",
      info1: `For Currency Research, the results exceeded expectations:`,
      info2: `<ul style="list-style-type: disc; padding-left: 20px">
      <li class='mb-2'><b>Unprecedented Engagement:</b> Attendees not only embraced Premagic but also actively participated in the process. </li>
      <li class='mb-2'><b>Organic Social Reach:</b>The stream of user-generated content on social media expanded the event’s visibility far beyond the venue. </li>
      <li class='mb-2'><b>Audience Delight:</b>CR discovered that older attendees valued professional photos even more than their younger counterparts.</li>
      </ul>`,

      gridViewTitle: "Key Features That Made It Work",
      inlineLink: {
        text: "HOW NASSCOM EMPOWERED SPONSOR-AUDIENCE ENGAGEMENT WITH PREMAGIC",
        link: "https://premagic.com/case-study/nasscom",
      },
      gridViewData: [
        {
          title: "AI-powered photo distribution:",
          description: `Seamlessly connecting attendees with their event photos using facial recognition.`,
        },
        {
          title: "Social Sharing Prompts:",
          description: `Turning every attendee into a potential ambassador with easy social media sharing options.`,
        },
        {
          title: "Effortless Implementation:",
          description: `No steep learning curves or complicated workflows—just instant results.`,
        },
      ],
    },
    {
      title: "Looking Ahead",
      info1: `What began as a tool for engagement evolved into a mindset shift.  With Premagic, Currency Research unlocked a new way to engage its audience, proving that innovation isn’t just for younger crowds.<br/><br/>Premagic’s seamless experience built a foundation of trust, leading CR to sign a <b>yearly contract</b>, with Premagic for future events<br/><br/>Ready to turn your next event into a viral success?.<br/><br/>Discover how Premagic can revolutionize engagement at your events.`,
    },
  ],
  isCTAActive: true,
}

export default currencyResearchData
